var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoomServiceSolid = function SvgRoomServiceSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.999 9a6 6 0 0 0-12 0h12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.004 17.007h2.334a2 2 0 0 0 1.2-.4l2.418-1.813a1.515 1.515 0 0 1 1.98 2.284l-2.073 2.074c-.559.559-1.27.94-2.045 1.094l-2.931.587a4.003 4.003 0 0 1-1.756-.042l-2.651-.663a3.96 3.96 0 0 0-.97-.12H7.002m6.004-3.001h1.486c.837 0 1.516-.679 1.516-1.516v-.3c0-.695-.473-1.301-1.148-1.47l-2.293-.573a4.692 4.692 0 0 0-3.746.646l-1.817 1.212h-4v4.999h4M3.999 9h16m-2 0a6 6 0 0 0-12 0h12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRoomServiceSolid;